import { render, staticRenderFns } from "./restricoes-estado.vue?vue&type=template&id=81c7f974&"
import script from "./restricoes-estado.vue?vue&type=script&lang=js&"
export * from "./restricoes-estado.vue?vue&type=script&lang=js&"
import style0 from "./restricoes-estado.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports